import type { TutorialPageDef } from '../types';

export const generalTutorials: TutorialPageDef[] = [
  {
    key: 'home',
    label: 'ホーム',
    paths: ['/home'],
    steps: [
      {
        target: 'home-sidebar',
        title: 'サイドバーのご案内',
        body: 'ここから広告制作やチャットなど、すべての機能に移動できます。',
      },
      {
        target: 'home-sidebar-ads',
        title: '広告制作メニュー',
        body: 'バナーや動画、漫画広告などの作成画面はこちらから開けます。',
      },
      {
        target: 'home-sidebar-news',
        title: 'ニュース',
        body: '新機能やお知らせをここで確認できます。',
      },
      {
        target: 'home-sidebar-account',
        title: 'アカウント・クレジット',
        body: '組織情報やアカウント設定、クレジット残高はここから確認できます。',
      },
      {
        target: 'home-quick-actions',
        title: '今すぐ始める',
        body: 'よく使う機能にワンクリックでアクセスできます。',
      },
      {
        target: 'home-recent-work',
        title: '最近の作業',
        body: '直近で作成したチャットや画像などの履歴を確認できます。',
      },
      {
        target: 'home-credit-balance',
        title: 'クレジット残高',
        body: '今月使えるクレジットの残量と生成件数を確認できます。',
      },
    ],
  },
  {
    key: 'recent-works',
    label: '最近の作業',
    paths: ['/recent-works'],
    steps: [
      {
        title: '最近の作業',
        body: 'AIチャットや画像・動画生成、漫画広告などの履歴をまとめて確認できます。',
      },
      {
        target: 'recent-works-list',
        title: '作業一覧',
        body: '項目をクリックすると詳細を確認したり、続きの作業に戻れます。',
      },
    ],
  },
  {
    key: 'chat',
    label: 'AIチャット',
    paths: ['/chat/ai', '/chat/new', '/chat/:chatId', '/chat/super-agent'],
    steps: [
      {
        target: 'chat-input',
        title: 'メッセージ入力',
        body: 'ここにやりたいことを入力してAIに相談できます。',
      },
      {
        target: 'chat-mode-toggle',
        title: '画像・動画モード',
        body: '選択すると、チャットのまま画像や動画を生成できます。',
      },
      {
        target: 'chat-model-select',
        title: 'AIモデルの選択',
        body: '用途に合わせてAIモデルを切り替えられます。',
      },
      {
        target: 'chat-send',
        title: '送信',
        body: 'メッセージを送信するとAIが応答や生成を開始します。',
      },
      {
        target: 'chat-history',
        title: 'チャット履歴',
        body: '過去の会話はここから見返したり、続きから再開できます。',
      },
    ],
  },
  {
    key: 'image-generation',
    label: '素材生成',
    paths: ['/image-generation'],
    steps: [
      {
        target: 'image-generation-prompt',
        title: 'プロンプト入力',
        body: '作りたい画像の内容を文章で入力します。',
      },
      {
        target: 'image-generation-style',
        title: 'スタイル選択',
        body: '画像の雰囲気やデザインのスタイルを選べます。',
      },
      {
        target: 'image-generation-generate',
        title: '生成する',
        body: 'ボタンを押すと入力した内容で画像が生成されます。',
      },
      {
        target: 'image-generation-results',
        title: '生成した画像一覧',
        body: '過去に生成した画像を確認・ダウンロードできます。',
      },
    ],
  },
  {
    key: 'knowledge',
    label: '商品情報',
    paths: ['/knowledge', '/standalone-knowledge'],
    steps: [
      {
        target: 'knowledge-search',
        title: '商品を検索',
        body: '登録済みの商品やサービスをキーワードで検索できます。',
      },
      {
        target: 'knowledge-add',
        title: '商品を登録',
        body: '新しい商品やサービスの情報をここから追加できます。',
      },
      {
        target: 'knowledge-product-list',
        title: '商品一覧',
        body: '選択した商品の情報や広告への活用状況を確認できます。',
      },
      {
        target: 'knowledge-tabs',
        title: '商品情報タブ',
        body: '戦略マップや商品画像、ブランド情報などを切り替えて確認できます。',
      },
    ],
  },
  {
    key: 'news',
    label: 'ニュース',
    paths: ['/news'],
    steps: [
      {
        title: 'ニュース',
        body: '新機能やお知らせなど、最新の更新情報をお届けします。',
      },
      {
        target: 'news-list',
        title: '記事一覧',
        body: '気になる記事をクリックすると詳細を確認できます。',
      },
    ],
  },
  {
    key: 'news-detail',
    label: 'ニュース（記事）',
    paths: ['/news/:id'],
    steps: [
      {
        target: 'news-detail-back',
        title: '一覧に戻る',
        body: 'ここから記事一覧にすぐ戻れます。',
      },
    ],
  },
];
